export const FILE_UPLOAD = "FILE_UPLOAD";
export const FILE_UPLOAD_START = "FILE_UPLOAD_START";
export const FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED";
